import { topicsData } from '@/mocks/home';

const heatColorMap: Record<string, string> = {
  '爆': 'bg-secondary-500 text-white',
  '热': 'bg-primary-500 text-white',
  '新': 'bg-accent-500 text-white',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">热门话题</h2>
          <p className="text-foreground-600 text-sm md:text-base">全网热议话题实时追踪</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <div
              key={topic.id}
              className="group flex items-center gap-3 px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <span className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{topic.name}
              </span>
              {topic.heat && (
                <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${heatColorMap[topic.heat] || 'bg-background-200 text-foreground-600'}`}>
                  {topic.heat}
                </span>
              )}
              <span className="text-xs text-foreground-500 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}